import script from "./AddUserWithGroupFieldGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUserWithGroupFieldGroup.vue?vue&type=script&setup=true&lang=js"

import "./AddUserWithGroupFieldGroup.vue?vue&type=style&index=0&id=3406f586&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3406f586"]])

export default __exports__